import { colors } from './colors';
import { fonts } from './fonts';

const theme = {
  colors,
  fonts
};

export default theme;
